<div class="email-widget">
  <div class="background-area" [ngStyle]="{ 'background-image' : getBackground(page.image), 'background-position' : getBackgroundPosition() }">
    <div *ngIf="page.title" (click)="open()" class="title-wrapper" [ngStyle]="setBGStyle()">
      <h4 [ngStyle]="setFontStyle()" class="card-title" [ngClass]="{'largeLabels': page.largeLabels}">{{page.title | i18n}}</h4>
      <h5 [ngStyle]="setFontStyle()" class="card-title" [ngClass]="{'largeDescription': page.largeLabels}">{{page.description | i18n}}</h5>
    </div>
  </div>
</div>
